export default __webpack_public_path__ + "static/media/student-accounts.1d2bedae.png";